import { Component } from '@angular/core'
import { CurrentProductService } from '@spartacus/storefront'
import { distinctUntilChanged, filter, map, switchMap, tap } from 'rxjs/operators'
import { MbProductTabResourcesConnector } from '../../../connectors/resources'
import { isNotNullable } from '@spartacus/core'
import { MbResourcesEntry } from '../../../../models'

@Component({
  selector: 'mb-pdp-resources-tab',
  templateUrl: './pdp-resources-tab.component.html',
  styleUrls: ['./pdp-resources-tab.component.scss']
})
export class PdpResourcesTabComponent {

  productName = ''
  product$ = this.currentProductService.getProduct().pipe(
    filter(isNotNullable),
  )
  resources$ = this.product$.pipe(
    tap(product => this.productName = product?.nameHtml || ''),
    map(product => product.originalCode),
    filter(Boolean),
    distinctUntilChanged(),
    switchMap(productCode => this.productResourceConnector.get(productCode as string))
  )

  constructor (protected currentProductService: CurrentProductService,
              protected productResourceConnector: MbProductTabResourcesConnector) {
  }

  sortBySortOrder (docsAndProtocols: MbResourcesEntry[]) {
    return docsAndProtocols.sort((a, b) =>
      a.sortOrder && b.sortOrder && a.sortOrder - b.sortOrder || 0)
  }
}
